
import { ProjectService } from './service';

function initialState()
{
    return {
        data: [],
        tags: [],
        technologies: [],
        types: [],
        categories: [],
        searchOptions: [],
        query: {
            page: 1
        },
        loading: false
    }
}

const getters = {
    data: state => state.data,
    total: state => state.data.length,
    loading: state => state.loading,
    tags: state => state.tags,
    types: state => state.types,
    categories: state => state.categories,
    technologies: state => state.technologies,
    searchOptions: state => state.searchOptions
};

const actions = {
    fetchData({ commit, dispatch, state }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            ProjectService.fetchData(state.query)
                .then(response => {
                    commit('setData', response.data.data);
                    resolve(response.data.data)
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        });
    },
    fetchTags({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            ProjectService.fetchTags()
                .then(response => {
                    commit('setTags', response.data);
                    resolve()
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
        });
    },
    fetchTechnologies({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            ProjectService.fetchTechnologies()
                .then(response => {
                    commit('setTechnologies', response.data);
                    resolve()
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
        });
    },
    fetchTypes({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            ProjectService.fetchTypes()
                .then(response => {
                    commit('setTypes', response.data);
                    resolve()
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
        });
    },
    fetchCategories({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            ProjectService.fetchCategories()
                .then(response => {
                    commit('setCategories', response.data);
                    resolve()
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
        });
    },
    fetchSearchOptions({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            ProjectService.fetchSearchOptions()
                .then(response => {
                    commit('setSearchOptions', response.data);
                    resolve()
                })
                .catch(error => {
                    console.error(error);
                    reject(error)
                })
        });
    },
    setQuery({ commit }, value) {
        commit('setQuery', value)
    },
    nextPage({ commit }) {
        commit('nextPage')
    },
    resetState({ commit }) {
        commit('resetState')
    },
    resetData({ commit }) {
        commit('resetData')
    }
};

const mutations = {
    setData(state, items) {
        state.data.push(...items)
    },
    setTags(state, items) {
        state.tags = items;
    },
    setTechnologies(state, items) {
        state.technologies = items
    },
    setTypes(state, items) {
        state.types = items
    },
    setCategories(state, items) {
        state.categories = items
    },
    setSearchOptions(state, items) {
        state.searchOptions = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setQuery(state, query) {
        state.query = Object.assign({page: 1}, query);
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    resetData(state) {
        state.data = [];
    },
    nextPage(state) {
        state.query.page += 1;
    }
};

export default {
        namespaced: true,
        state: initialState,
        getters,
        actions,
        mutations
    }



// WEBPACK FOOTER //
// ./resources/js/store/modules/Projects/index.js